var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Search Form","active":""}},[_c('b-form-group',[_c('sid-flex-direction',{attrs:{"sid":_vm.className(),"rule-name":"flex-direction"}}),_c('sid-buttons-group',{attrs:{"label":"Alignment","options":[
          {
            svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'10.04\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 10.04 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'5.54224\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 5.54224 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.5555\' height=\'0.91364\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.913574 14.5557)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
            customProperties: [[_vm.className(), ['margin-left', '']], [_vm.className(), ['margin-right', '']], [_vm.className(), ['--align', 'start']]],
            value: 'start',
            tooltip: 'Start'
          },
          {
            svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'3.9668\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 3.9668 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'10.4326\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 10.4326 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.3631\' height=\'0.901561\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 5.59766 14.363)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
            customProperties: [[_vm.className(), ['margin-left', 'auto']], [_vm.className(), ['margin-right', 'auto']], [_vm.className(), ['--align', 'center']]],
            value: 'center',
            tooltip: 'Center'
          },
          {
            svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'16\' viewBox=\'0 0 11 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 0 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 4.7002 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'9.53613\' y=\'16\' width=\'15.2079\' height=\'0.95459\' transform=\'rotate(-90 9.53613 16)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
            customProperties: [[_vm.className(), ['margin-left', 'auto']], [_vm.className(), ['margin-right', '']], [_vm.className(), ['--align', 'end']]],
            value: 'end',
            tooltip: 'End'
          }
        ],"sid":_vm.className(),"rule-name":"--align"}})],1),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Gap","sid":_vm.className(),"rule-name":"gap"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Input Field"}},[_c('b-form-group',[_c('div',{staticClass:"flex gap-[14px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .input')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex gap-[14px] items-center"},[_c('label',{staticClass:"pb-0"},[_vm._v("Placeholder Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .input::placeholder')}})],1)]),_c('sid-background',{attrs:{"sid":_vm.className(' .input')}}),_c('sid-range-slider',{attrs:{"label":"Height","sid":_vm.className(' .input'),"rule-name":"height","default-dimension":"px","dimensions":[],"var":"--height"}}),_c('sid-range-slider',{attrs:{"label":"Width","sid":_vm.className(),"rule-name":"width","default-dimension":"%","dimensions":[],"var":"--width"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' .input'),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' .input'),"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' .input'),"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(' .input'),"rule-name":"border","angles":[
        {
          text: '',
          value: 'top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius'
        }
      ]}}),_c('sid-box-shadow',{attrs:{"sid":_vm.className(' .input'),"rule-name":"box-shadow"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Button"}},[_c('SidbearSettingsGroup',{attrs:{"title":"Main Text","active":"","content-class":"border-0"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('sid-font',{attrs:{"sid":_vm.className(' button.search-button')}}),_c('sid-range-slider',{attrs:{"label":"Text Size","sid":_vm.className(' button.search-button'),"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":_vm.className(' button.search-button'),"rule-name":"letter-spacing"}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":_vm.className(' button.search-button'),"rule-name":"line-height"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"color"}})],1)]),_c('sid-align',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"justify-content","label":"Text Alignment"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"p-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"font"}})],1)])],1),_c('template',{slot:"Hover"},[_c('sid-range-slider',{attrs:{"label":"Text Size","sid":_vm.className(' button.search-button'),"rule-name":"font-size","presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":_vm.className(' button.search-button'),"rule-name":"letter-spacing","presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":_vm.className(' button.search-button'),"presudo":":hover","rule-name":"color"}})],1)])],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Layout & Style"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-align',{attrs:{"sid":_vm.className(' .search-button'),"rule-name":"justify-content","label":"Button Alignment"}}),_c('sid-background',{attrs:{"sid":_vm.className(' button.search-button')}}),_c('sid-range-slider',{attrs:{"label":"Width","sid":_vm.className(' button.search-button'),"rule-name":"width","var":"--width","default-dimension":"%","dimensions":['px', '%'],"measurement":"width"}}),_c('sid-range-slider',{attrs:{"label":"Height","sid":_vm.className(' button.search-button'),"rule-name":"height","var":"--height","default-dimension":"px","dimensions":['px', '%']}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-background',{attrs:{"sid":_vm.className(' button.search-button'),"presudo":":hover"}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' button.search-button'),"label":"Border Width","rule-name":"border","angles":[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":_vm.className(' button.search-button'),"rule-name":"border","angles":[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' button.search-button'),"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' button.search-button'),"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":_vm.className(' button.search-button'),"rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]}})],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"box-shadow"}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":_vm.className(' button.search-button'),"presudo":":hover","rule-name":"box-shadow"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Transform"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-transform',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"transform","section":_vm.section}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-transform',{attrs:{"sid":_vm.className(' button.search-button'),"rule-name":"transform","presudo":":hover","section":_vm.section}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .search-button button.search-button'),"rule-name":"padding","min":0,"angles":[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]}}),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":_vm.className(' .search-button'),"rule-name":"margin","min":-2000,"max":2000,"angles":[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]}})],1)],1),_c('sidbear-settings-group',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":_vm.className(),"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }